export default __webpack_public_path__ + "src/assets/icn-toast-swap.57decf89a3418ec6a90c8f0c2ca5069d.svg";